app.controller('BrowseProductListCabinetKitchenController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;

    $scope.product_model = $rootScope.factory.product_cabinet_kitchen.getModel(navigationIDs);
    $scope.product_model.apiRequire();
    const clicboxColourModel = $rootScope.factory.clicbox_colour.getModel(navigationIDs);
    $scope.clicbox_colour_choice = clicboxColourModel.choices[navigationIDs.clicbox_colour_id]

    $scope.isProductFiltered = function (selectID, product) {
        const parentCategoryID = navigationIDs.parent_category_id ? navigationIDs.parent_category_id : selectID;
        if (parentCategoryID) {
            if (!product.parent_category_ids || !product.parent_category_ids.includes(parentCategoryID)) {
                return true;
            }
        }
        if (navigationIDs.clicbox_colour_id) {
            if (!product[navigationIDs.clicbox_colour_id]) {
                return true;
            }
        }
        return false;
    }

    $scope.list_item_include = "views/browse/product/browse-product-item-cabinet-kitchen.htm";
    $scope.list_current_txt = "Current Kitchen Cabinet Type";


    $scope.addToCartHandler = function (validateFormCallback, product) {

        const orderLine = {

            type: "clicbox",
            unit: product.id,

            quantity: product.quantity,
            cost: product.displayPrice({clicbox_colour: navigationIDs.clicbox_colour_id}),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.clicbox_colour_id,
            carcass_colour: navigationIDs.clicbox_colour_id,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            lines: [orderLine]
        };

        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {
                $rootScope.service.product.resetProduct(product);
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };

}]);